import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import CategoryGrid from "./components/CategoryGrid";
import ArticlePreview from "./components/ArticlePreview";
import ContentSection from "./components/ContentSection";
import FAQSection from "./components/FAQSection";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL;

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Was ist OOPBUY?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "OOPBUY ist ein führender Shopping-Agent für chinesische Marktplätze wie Taobao, Weidian und 1688. Die Plattform ermöglicht es Käufern weltweit, Produkte aus China zu bestellen, die Qualität zu prüfen (QC) und sicher nach Deutschland sowie in andere Länder versenden zu lassen."
      }
    },
    {
      "@type": "Question",
      "name": "Was ist oopbuyspread.beer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "oopbuyspread.beer ist eine unabhängige Informationsplattform und ein kuratierter Guide für OOPBUY-Käufer. Wir bieten die größte öffentlich zugängliche Spreadsheet mit über 3.000 verifizierten Produkten, täglich aktualisiert."
      }
    },
    {
      "@type": "Question",
      "name": "Warum sollte ich eine Website-Spreadsheet nutzen?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Eine kuratierte Spreadsheet spart dir Stunden an Recherche. Statt stundenlang Taobao oder Weidian nach vertrauenswürdigen Verkäufern zu durchsuchen, findest du bei uns bereits geprüfte Produkte mit verifizierten QC-Fotos."
      }
    },
    {
      "@type": "Question",
      "name": "Wie bekomme ich zusätzlichen Support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Für Support bei Bestellungen, Versandfragen oder spezifischen Produktanfragen empfehlen wir dir, den offiziellen OOPBUY-Kundenservice zu kontaktieren. Für Fragen zu unserer Spreadsheet kannst du die Guides auf dieser Seite lesen."
      }
    },
    {
      "@type": "Question",
      "name": "Wie platziere ich eine Bestellung bei OOPBUY?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "1. Erstelle ein Konto auf der offiziellen OOPBUY-Website. 2. Suche das gewünschte Produkt oder nutze unsere Spreadsheet. 3. Füge den Produktlink in deinen Warenkorb ein. 4. Wähle deine Optionen. 5. Bezahle und warte auf QC-Fotos. 6. Bestätige den Versand nach Deutschland."
      }
    },
    {
      "@type": "Question",
      "name": "Können Sie mir bei der Suche nach einem bestimmten Produkt helfen?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Unsere Spreadsheet deckt die beliebtesten Kategorien ab: Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und mehr."
      }
    },
    {
      "@type": "Question",
      "name": "Warum OOPBUY statt anderer Shipping Agents?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "OOPBUY besticht durch eine benutzerfreundliche Oberfläche, schnelle QC-Fotos, wettbewerbsfähige Versandpreise und einen zuverlässigen Kundenservice. Die Plattform unterstützt alle gängigen chinesischen Marktplätze."
      }
    },
    {
      "@type": "Question",
      "name": "Was ist eine OOPBUY Spreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Eine OOPBUY Spreadsheet ist eine öffentlich zugängliche Liste kuratierter Produkte von verifizierten Verkäufern. Jeder Eintrag enthält Produktlinks, Preise, Verkäuferbewertungen und QC-Fotos."
      }
    }
  ]
};

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "OOPBUY Spreadsheet Deutschland",
  "url": siteUrl,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg",
  "description": "Die beste OOPBUY Spreadsheet für Deutschland. Über 3.000 handverlesene Produkte, täglich aktualisiert.",
  "sameAs": ["https://kaspreadsheet.com"]
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategoryGrid />
        <ArticlePreview />
        <ContentSection />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}